import './ConfigErrorScreen.css';

export function ConfigErrorScreen({ message }: { message: string }) {
  return (
    <div className="nx-config-error">
      <div className="nx-config-error__card">
        <h1 className="nx-config-error__title">Nexsoss Operator Console cannot start</h1>
        <p className="nx-config-error__lede">
          The runtime configuration is missing or invalid. The application cannot render safely.
        </p>
        <pre className="nx-config-error__details" data-testid="config-error-message">
          {message}
        </pre>
        <p className="nx-config-error__hint">
          See <code>docs/runbooks/runtime-config.md</code>.
        </p>
      </div>
    </div>
  );
}